import { useEffect, useState } from 'react';
import { InputText, IconTrash, DateInput, PickerPosition } from '@ui/src';
import { EntityIdentificationsFormValues } from '../../hoc/types';
import { IndentificationEntityTypes } from './types';

import cn from './blacklist.module.css';

const IdentificationEntity = ({
  identification,
  setIdentifications,
  identifications,
  length,
  id,
}: IndentificationEntityTypes) => {
  const [values, setValues] = useState<EntityIdentificationsFormValues>();

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const nextValues = { ...values };

    if (e.target.name === `administrativeUnitName-${id}`) {
      nextValues.administrativeUnitName = e.target.value;
    } else if (e.target.name === `isoStandard-${id}`) {
      nextValues.isoStandard = e.target.value;
    } else if (e.target.name === `identificationIssuer-${id}`) {
      nextValues.identificationIssuer = e.target.value;
    } else if (e.target.name === `identificationTypeDesc-${id}`) {
      nextValues.identificationTypeDesc = e.target.value;
    } else if (e.target.name === `identificationNumber-${id}`) {
      nextValues.identificationNumber = e.target.value;
    } else if (e.target.name === `issueDateValue-${id}`) {
      nextValues.issueDateValue = e.target.value;
    } else if (e.target.name === `expirationDateValue-${id}`) {
      nextValues.expirationDateValue = e.target.value;
    }

    setValues(nextValues as EntityIdentificationsFormValues);

    if (identifications) {
      const nextIdentifications = identifications?.map((item) => {
        let result = { ...item };

        if (result.id === identification?.id) {
          result = nextValues as EntityIdentificationsFormValues;
        }

        return result;
      });

      setIdentifications(
        nextIdentifications,
      );
    }
  };

  useEffect(() => {
    if (identification) {
      setValues(identification);
    }
  }, [identification]);

  return (
    <div className={cn.entityWrapper}>
      <div className={cn.entityValue} style={{ width: `${100 / length}%` }}>
        <InputText
          name={`identificationTypeDesc-${id}`}
          value={values?.identificationTypeDesc}
          placeholder="Enter type"
          onChange={onChange}
          className={cn.borderless}
        />
      </div>
      <div className={cn.entityValue} style={{ width: `${100 / length}%` }}>
        <InputText
          name={`identificationIssuer-${id}`}
          value={values?.identificationIssuer}
          placeholder="Enter issuer"
          onChange={onChange}
          className={cn.borderless}
        />
      </div>
      <div className={cn.entityValue} style={{ width: `${100 / length}%` }}>
        <InputText
          name={`identificationNumber-${id}`}
          value={values?.identificationNumber}
          placeholder="Enter number"
          onChange={onChange}
          className={cn.borderless}
        />
      </div>
      <div className={cn.entityValue} style={{ width: `${100 / length}%` }}>
        <InputText
          name={`administrativeUnitName-${id}`}
          value={values?.administrativeUnitName}
          placeholder="Enter country"
          onChange={onChange}
          className={cn.borderless}
        />
      </div>
      <div className={cn.entityValue} style={{ width: `${100 / length}%` }}>
        <InputText
          name={`isoStandard-${id}`}
          value={values?.isoStandard}
          placeholder="Enter ISO"
          onChange={onChange}
          className={cn.borderless}
        />
      </div>
      <div className={cn.entityValue} style={{ width: `${100 / length}%` }}>
        <DateInput
          value={values?.issueDateValue}
          onChange={(date) => {
            onChange({
              target: {
                name: `issueDateValue-${id}`,
                value: date?.toISOString(),
              },
            } as React.ChangeEvent<HTMLInputElement>);
          }}
          placeholder="Select issue date"
          className={cn.identificationDatePicker}
          pickerPisition={PickerPosition.RIGHT}
          pickerClassName={cn.identificationDatePickerCalender}
          withoutIcon
          withoutCustomSelector
        />
      </div>
      <div
        className={`${cn.entityValue} ${cn.flex}`}
        style={{ width: `${100 / length}%` }}
      >
        <DateInput
          value={values?.expirationDateValue}
          onChange={(date) => {
            onChange({
              target: {
                name: `expirationDateValue-${id}`,
                value: date?.toISOString(),
              },
            } as React.ChangeEvent<HTMLInputElement>);
          }}
          placeholder="Select expiration date"
          className={cn.identificationDatePicker}
          pickerPisition={PickerPosition.RIGHT}
          pickerClassName={cn.identificationDatePickerCalender}
          withoutIcon
          withoutCustomSelector
        />
        <button
          type="button"
          className={cn.deleteEntityButton}
          onClick={() => {
            setIdentifications(
              identifications?.filter(
                (item) => item.id !== id,
              ) as EntityIdentificationsFormValues[],
            );
          }}
        >
          <IconTrash />
        </button>
      </div>
    </div>
  );
};

export default IdentificationEntity;
